import { DateRangeFilterModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/models/inputs/date-range-filter.model';
import { useTranslation } from 'react-i18next';

import { DateRangeFilterController } from '@shared/filter/date-range-filter/date-range-filter.controller';

interface ChargePointListLastMessageReceivedDateFilterControllerProps {
  value?: DateRangeFilterModel;
  onChange: (value: DateRangeFilterModel | undefined) => void;
}

export const ChargePointListLastMessageReceivedDateFilterController = ({
  value,
  onChange,
}: ChargePointListLastMessageReceivedDateFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <DateRangeFilterController
      iconName="calendar-date"
      text={t(
        'delmonicos-shared-sdk.outputs-charge-point.last-message-received-date',
      )}
      fromLabel={t(
        '$.charge-point-list-last-message-received-date-filter.from',
      )}
      toLabel={t('$.charge-point-list-last-message-received-date-filter.to')}
      value={value}
      onChange={onChange}
    />
  );
};
